import { ROUTES_NAMES } from '@/constants';
import { beforeEnterRegistrationRoute } from './registrationNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import RegistrationPanel from '@/views/RegistrationPanel.vue';

const registrationRoute: RouteRecordRaw = {
  path: '/registration',
  name: ROUTES_NAMES.registration,
  component: RegistrationPanel,
  beforeEnter: beforeEnterRegistrationRoute
};

export default registrationRoute;
